import { render } from "./Navigation.vue?vue&type=template&id=bb990eb6&scoped=true&ts=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./navigation.scss?vue&type=style&index=0&id=bb990eb6&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb990eb6"]])

export default __exports__